const Loader = () => 'Carregando...';

export default Loader;
